enum RegistrationStep {
  LOOKUP = 'lookup',
  REGISTRATION = 'registration',
  COMPLETE = 'complete'
}

export default RegistrationStep
